import dummyezi from "../assets/images/dummy/dummyezi.png";

/**
 * Get image source with fallback to dummy image
 * @param {string} imagePath - The image path to display
 * @param {string} fallbackType - Type of fallback: 'user' for profile image, 'item' for item image
 * @returns {object} Object with src, alt, and shouldShowFallback
 */
export const getImageWithFallback = (imagePath, fallbackType = 'item') => {
  // Shop/food-item images are stored on the backend as arrays (e.g. ["/images/x.jpg"]),
  // so a plain typeof === 'string' check always failed for real uploads and silently
  // fell back to the dummy image. Resolve to the first non-empty string, whether the
  // value is a plain string or an (possibly nested) array.
  const resolved = Array.isArray(imagePath)
    ? imagePath.flat(Infinity).find((item) => typeof item === 'string' && item.trim() !== '')
    : imagePath;

  const hasImage = !!resolved && typeof resolved === 'string' && resolved.trim() !== '';

  return {
    src: hasImage ? resolved : dummyezi,
    alt: hasImage ? 'Image' : `No ${fallbackType} image found`,
    shouldShowFallback: !hasImage,
    isDummy: !hasImage,
  };
};

/**
 * Render image with error handling
 * @param {string} src - Image source
 * @param {function} onError - Error handler callback
 * @returns {object} Image props
 */
export const getImageProps = (src, onError) => {
  return {
    src: src || dummyezi,
    onError: (e) => {
      e.target.src = dummyezi;
      if (onError) onError(e);
    },
    alt: 'Image not available',
  };
};
